module.exports = __webpack_public_path__ + "static/media/logo-latam.9879ebf7.svg";